import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDDPSubscription } from '@zedoc/ddp-connector';
import { useSelector } from 'react-redux';
import Participation from '../../../common/models/Participation';
import {
  PATIENT_STATUS_DECEASED,
  PATIENT_STATUS_ACTIVE,
  PATIENT_STATUS_INACTIVE,
} from '../../../common/constants';
import ConfirmAction from '../../dialogs/ConfirmAction';
import FormFieldWrapper from '../../forms/FormFieldWrapper';
import Select from '../../Select';
import { notifySuccess } from '../../../utils/notify';

const PatientStatus = ({ recipient, updateRecipientStatus, isInActive }) => {
  const { t } = useTranslation();
  const currentStatus = useMemo(() => {
    let status = recipient && recipient.status;
    return status || PATIENT_STATUS_ACTIVE;
  }, [recipient]);

  const [selectedStatus, setSelectedStatus] = useState('');
  const Statuses = [
    {
      label: t(`states:${PATIENT_STATUS_ACTIVE.toLowerCase()}`),
      value: PATIENT_STATUS_ACTIVE,
    },
    {
      label: t(`states:${PATIENT_STATUS_INACTIVE.toLowerCase()}`),
      value: PATIENT_STATUS_INACTIVE,
    },
    {
      label: t(`states:${PATIENT_STATUS_DECEASED.toLowerCase()}`),
      value: PATIENT_STATUS_DECEASED,
    },
  ];
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const handleOnOpenDialog = () => setIsDialogVisible(true);
  const handleOnCloseDialog = () => setIsDialogVisible(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleOnChangeMethod = (status) => {
    setSelectedStatus(status);
    handleOnOpenDialog();
  };
  const handleOnDialogConfirm = () => {
    setIsLoading(true);
    updateRecipientStatus(selectedStatus);
    handleOnCloseDialog();
    notifySuccess(
      t('confirmations:patientStatus.success', {
        status: selectedStatus.toUpperCase(),
      }),
    )();
    setIsLoading(false);
  };
  const label = useMemo(() => {
    if (isInActive) {
      return (
        <span>
          {t('forms:patientStatus.label')}
          <span
            style={{
              color: '#F59E0B',
              fontWeight: 'bold',
            }}
          >
            ({t('patientBlocked')})
          </span>
        </span>
      );
    }
    return t('forms:patientStatus.label');
  }, [isInActive, t]);
  return (
    <>
      <FormFieldWrapper label={label}>
        <Select
          options={Statuses}
          value={currentStatus}
          onChange={handleOnChangeMethod}
        />
      </FormFieldWrapper>
      <ConfirmAction
        message={t('confirmations:patientStatus.message', {
          status: selectedStatus.toUpperCase(),
        })}
        open={isDialogVisible}
        onConfirm={handleOnDialogConfirm}
        onCancel={handleOnCloseDialog}
        loading={isLoading}
      />
    </>
  );
};

export default PatientStatus;
